<template>
  <div
    id="quest-menu"
    v-if="hasQuests"
    class="quest-menu pull-left"
    v-show="notOnProjectSelectionPage"
  >
    <b-nav class="quests" id="quests" aria-label="quests">
      <template v-for="quest in menu">
        <b-nav-item
          v-if="quest.type != 'menu'"
          active-class="active"
          :key="quest.id"
          :id="'quest-' + quest.id"
          :active="isActive(quest)"
          @click.prevent="changeQuest(quest)"
          ><span :style="fontStyle(quest)">{{ quest.caption }}</span></b-nav-item
        >
        <b-nav-item-dropdown v-else :key="quest.id">
          <template v-slot:text>{{quest.caption}}</template>
          <b-dropdown-item
            href="#"
            v-for="subQuest in quest.quests"
            :key="subQuest.id"
            :id="'quest-' + subQuest.id"
            :active="isActive(subQuest)"
            @click.prevent="changeQuest(subQuest)"
            >{{ subQuest.caption }}</b-dropdown-item
          >
        </b-nav-item-dropdown>
      </template>
      <b-nav-item v-if="showExpandToggle" class="ml-auto" @click.prevent="toggleExpand">
        <b-icon-arrows-angle-contract v-if="expanded"/>
        <b-icon-arrows-angle-expand v-else/>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
//---- mixins -------------
import QuestMenuMixins from "./QuestMenuMixins.js";
//---- services -----------
import { appLocalStorage } from "@/app/services/app-storage.js";
//---- 3rd-parties --------
import { BIconArrowsAngleContract, BIconArrowsAngleExpand } from "bootstrap-vue";

export default {
  name: "quest-menu-standalone",
  data(){
    return {
      expanded: appLocalStorage.getItem('expanded', false)
    }
  },
  components: {BIconArrowsAngleContract, BIconArrowsAngleExpand},
  mixins: [QuestMenuMixins],
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
      appLocalStorage.setItem('expanded', this.expanded)
      this.$root.$emit('main-container-expansion-toggled', this.expanded)
    }
  },
  computed: {
    showExpandToggle() {
      // if screen is not at least xl, don't show the toggle because it will have no effect
      return !this.$route?.meta?.alwaysExpanded && this.$store.getters['xl'];
    }
  }
};
</script>
<style scoped>
.quest-menu {
  background-color: #e46c0a; /* fallback for IE */
  background-color: var(--quest-menu-bg-color);
  /* negative margins to compensate parent's padding */
  margin-left: -15px;
  margin-right: -15px;
  /* border-radius: 3px; */
}
/* .quests {
  margin-left: -0.5rem;
  
} */
.nav-link, .quest-menu >>> .nav-link {
  font-size: 0.9rem;
  color: white; /* fallback for IE */
  color: var(--quest-menu-color);
  /* padding: 0.125rem 0.5rem 0.375rem 0.5rem; */
}
.nav-link.active, .quest-menu >>> .nav-link.active {
  outline: none;
}
.nav-link:hover:not(.active), .quest-menu >>> .nav-link:hover:not(.active) {
  background-color: #b65607; /* fallback for IE */
  background-color: var(--primary-button-bg-hover-color);
  /* border-radius: 6px; */
}

.list-inline {
  font-size: 1.05rem;
  font-weight: 500;
}
.active, .quest-menu >>> .active {
  background-color: #b65607; /* fallback for IE */
  background-color: var(--primary-button-bg-hover-color);
  color: white;
  position: relative;
  text-decoration: none;
}


</style>
